import {permiteRol,tieneReservaGlobal} from './permisosRol';
import { leerRolDePerfil, leerEmpresaPrincipal } from './legacyData';
import { normalizarRol } from './roles';

export const ROLES_MODULO = {
  invitaciones: ['owner', 'socio', 'organizador', 'imagen', 'rrpp'],
  entradas: ['owner', 'socio', 'organizador', 'rrpp', 'imagen'],
  reservas: ['owner', 'socio', 'organizador', 'rrpp', 'imagen'],
  escaner: ['owner', 'socio', 'organizador', 'porteria'],
  reportes: ['owner', 'socio', 'organizador', 'administracion', 'barra'],
  eventos: ['owner', 'socio', 'organizador'],
  empresas: ['owner', 'socio', 'organizador'],
};

export const esMapa = (value) => !!value && typeof value === 'object' && !Array.isArray(value);
export const empresaPrincipal = (p = {}) => leerEmpresaPrincipal(p) || '';

export function empresasDelPerfil(p = {}) {
  const configured = p.empresasPermitidas;
  const ids = Array.isArray(configured) ? configured : esMapa(configured)
    ? Object.keys(configured).filter((id) => configured[id] === true)
    : [empresaPrincipal(p)];
  // Los IDs Firestore son sensibles a mayúsculas: no normalizar identidades.
  return [...new Set(ids.filter((id) => typeof id === 'string' && id.length > 0))];
}

export function rolPermiteModulo(rol, permiso,perfil={rol}) {
  const key={invitaciones:'invitaciones.generar',entradas:'entradas.vender',reservas:'reservas.ver',eventos:'eventos.ver',empresas:'empresas.ver'}[permiso];
  if(permiso==='escaner'&&!['escaner.invitaciones','escaner.entradas'].some(k=>permiteRol({...perfil,rol:normalizarRol(rol)},k)))return false;
  if(permiso==='reportes'&&!['invitaciones.ver','entradas.ver','reservas.ver'].some(k=>permiteRol({...perfil,rol:normalizarRol(rol)},k)))return false;
  if(key&&!permiteRol({...perfil,rol:normalizarRol(rol)},key))return false;
  rol = normalizarRol(rol);
  if (permiso === 'general') return Object.values(ROLES_MODULO).some((roles) => roles.includes(rol));
  return key?permiteRol({...perfil,rol},key):permiso==='reportes'?['reservas.ver','invitaciones.ver','entradas.ver'].some(k=>permiteRol({...perfil,rol},k)):permiso==='escaner'?['escaner.invitaciones','escaner.entradas'].some(k=>permiteRol({...perfil,rol},k)):(ROLES_MODULO[permiso]||[]).includes(rol);
}

export function flagsPermiten(rol, flags, permiso,perfil={rol}) {
  if (!esMapa(flags)) return false;
  if (permiso === 'general' || permiso === 'eventos') {
    return ['invitaciones', 'entradas', 'reservas', 'escaner', 'reportes']
      .some((key) => (key==='reportes'?['invitaciones.ver','entradas.ver'].some(k=>permiteRol(perfil,k)):rolPermiteModulo(rol,key,perfil)) && flags[key] === true);
  }
  return flags[permiso] === true;
}

export function puedeAccederEvento(perfil, evento, permiso = 'general') {
  if (!perfil || perfil.activo === false || !evento?.id) return false;
  const rol = leerRolDePerfil(perfil);
  if (!rolPermiteModulo(rol, permiso,perfil)) return false;
  if (rol === 'owner') return true;
  if(permiso==='eventos'&&permiteRol(perfil,'eventos.gestionar'))return true;
  if(permiso==='invitaciones'&&(evento.invitacionesConfig ? !evento.invitacionesConfig.habilitadas||!evento.invitacionesConfig.roles?.[rol]&&!evento.metasIncentivos?.some(r=>r.premio==='invitaciones'&&r.roles?.includes(rol)) : !['socio','organizador'].includes(rol)))return false;
  if(permiso==='escaner'&&Array.isArray(evento.rolesEscaner)&&!evento.rolesEscaner.includes(rol))return false;
  if (perfil.eventosBloqueados?.[evento.id] === true) return false;
  const permisos = esMapa(perfil.eventosPermitidos) ? perfil.eventosPermitidos : {};
  if (Object.prototype.hasOwnProperty.call(permisos, evento.id)) {
    return flagsPermiten(rol, permisos[evento.id], permiso,perfil);
  }
  return permiso==='reservas'&&tieneReservaGlobal(perfil)||empresasDelPerfil(perfil).includes(evento.empresaId);
}

// Se excluyen TODAS las excepciones de las queries por empresa. Después se
// recuperan por ID solo las que la política permite (incluidos bloqueos=false).
export function excepcionesEvento(perfil = {}) {
  return [...new Set([
    ...Object.keys(esMapa(perfil.eventosPermitidos) ? perfil.eventosPermitidos : {}),
    ...Object.keys(esMapa(perfil.eventosBloqueados) ? perfil.eventosBloqueados : {}),
  ])].filter((id) => id && !id.includes('/')).sort();
}
